import type {
  AssetStatus,
  AssetType,
  ContractType,
  ExpiryStatus,
} from "./api";

export const ASSET_TYPE_LABELS: Record<AssetType, string> = {
  hardware: "Hardware",
  software: "Software",
  network: "Network",
  peripheral: "Peripheral",
  other: "Other",
};

export const ASSET_STATUS_LABELS: Record<AssetStatus, string> = {
  active: "Active",
  in_repair: "In repair",
  retired: "Retired",
  lost: "Lost",
};

export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  amc: "AMC",
  warranty: "Warranty",
  extended_warranty: "Extended warranty",
};

/** Badge tone + text for a warranty / contract coverage status. */
export function expiryBadge(
  status: ExpiryStatus,
  days: number | null,
): { tone: "muted" | "success" | "warning" | "danger"; label: string } {
  switch (status) {
    case "active":
      return { tone: "success", label: days === null ? "Covered" : `${days}d left` };
    case "expiring_soon":
      return { tone: "warning", label: days === null ? "Expiring soon" : `${days}d left` };
    case "expired":
      return { tone: "danger", label: "Expired" };
    default:
      return { tone: "muted", label: "—" };
  }
}
